/**
 * Enumeration for the crash types.
 *
 * @readonly
 * @enum {string}
 */
export const CrashTypes = {
    PARKED: 'PARKED',
    DRIVING: 'DRIVING'
}

Object.freeze(CrashTypes)
